(function () {
	'use strict';

	angular
		.module('wizard-future7.directives')
		.directive('educationalSolutions', EducationalSolutions)

	/** @ngInject */
	function EducationalSolutions(PATHS) {
		function EducationalSolutionsController($state, HelperService) {
			const vm = this;
			let solution;

			init();

			function init() {
				solution = $state.params.solucao;
				vm.solutionSelecion = solution || 'mindset';

				if (solution)
					HelperService.scrollTo("#solutionWrapper");

			}
		}

		return {
			bindToController: true,
			controller: EducationalSolutionsController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/educational-solutions/educational-solutions.html`,
			scope: {}
		}
	}
}());